import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";
import {defineAsyncComponent} from "vue";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { LOCALE_CATEGORIES } from "@/assets/locales/categories";
import { PageHeaderConfig } from "@/components/navigation/usePageHeader";
import { i18n } from "@/i18n";
import router from "@/router";
import { WorkspaceId } from "@/sdk";

export function getEventsRouteRecord():RouteRecordRaw{
  return {
    name: 'events',
    path: '/workspace/:workspaceId/community/events',
    component: customAsyncComponent(async () => import('./views/EventsView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.LEXICON,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.COMMUNITY
      ]
    }
  }
}

export function getEventsRouteLocation(workspaceId: number, anchor?: string):RouteLocationRaw{
  return { name: 'events', params:{workspaceId}, hash: anchor || undefined }
}

export function getEventsRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getResourcesRouteRecord():RouteRecordRaw{
  return {
    name: 'resources',
    path: '/workspace/:workspaceId/community/resources',
    component: customAsyncComponent(async () => import('./views/ResourcesView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.LEXICON,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.COMMUNITY
      ]
    }
  }
}

export function getResourcesRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'resources', params:{workspaceId} }
}

export function getResourcesRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getGlossaryRouteRecord():RouteRecordRaw{
  return {
    name: 'glossary',
    path: '/workspace/:workspaceId/community/glossary',
    component: customAsyncComponent(async () => import('./views/GlossaryView.vue')),
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
        LOCALE_CATEGORIES.COMMUNITY
      ]
    }
  }
}

export function getGlossaryRouteLocation(workspaceId: number):RouteLocationRaw{
  return { name: 'glossary', params:{workspaceId} }
}

export function getGlossaryRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getGlossaryPageHeaderConfig(): PageHeaderConfig{
  return {
    showHome: false,
    showTitle: true,
    title: 'Hello Deborah !<br><em>What do you need today</em>',
    breadcrumb: []
  }
}